import {AppliedDiscount, AppliedDiscountDiscountType} from '@wix/auto_sdk_ecom_current-cart';
import {PriceModel} from './Price.model';
import {ModelContext} from '../../types/app.types';

export class CouponDiscountModel {
  public isFreeShippingCoupon: boolean;
  public amountOff: PriceModel;

  constructor(params: CouponDiscountModel) {
    this.isFreeShippingCoupon = params.isFreeShippingCoupon;
    this.amountOff = params.amountOff;
  }

  public static fromCartV1(appliedDiscounts: AppliedDiscount[], modelContext: ModelContext): CouponDiscountModel {
    const discount = appliedDiscounts.find((appliedDiscount) => appliedDiscount?.coupon);
    const coupon = discount?.coupon;
    if (!coupon) {
      return undefined;
    }
    return new CouponDiscountModel({
      isFreeShippingCoupon: discount?.discountType === AppliedDiscountDiscountType.SHIPPING,
      amountOff: PriceModel.fromCartV1(coupon.amount, modelContext),
    });
  }
}
